module.exports = __webpack_public_path__ + "static/phone_mock-44199fc626420780a0d10fa7f91737f1.png";